export default "__VITE_ASSET__DwwVd5Hj__"